import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 mx-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 mb-5" }, "\n        自動音声にて通知された4桁の認証コードを入力してください\n      ", -1)
const _hoisted_3 = { class: "my-5 text-size-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild mb-3" }, "数分待っても電話がかかってこない場合", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_SmsAuthForm = _resolveComponent("SmsAuthForm")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_SmsAuthWithPhoneSwitchContactForm = _resolveComponent("SmsAuthWithPhoneSwitchContactForm")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(),
      _createVNode(_component_SmsAuthForm, {
        modelValue: _ctx.latestPin,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.latestPin) = $event)),
        onInput: _ctx.onInputValidatePhoneAndTransition
      }, null, 8, ["modelValue", "onInput"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(),
        _createVNode(_component_AppButton, {
          size: "small",
          block: "",
          rounded: "",
          class: "mb-3",
          onClick: _ctx.onClickReCall
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n          再度電話を受ける\n        ")
          ], undefined, true),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createTextVNode(),
      _createVNode(_component_SmsAuthWithPhoneSwitchContactForm)
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}